import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {initTelemetry} from '@/functions/telemetryCollector'
import {initTurnstile} from '@/functions/turnstile'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/style/global.scss'

Array.prototype.asyncForEach = async function (callback, thisArg) {
    thisArg = thisArg || this;

    for (let index = 0, length = this.length; index !== length; ++index) {
        await callback.call(thisArg, this[index], index, this)
    }
};

initTelemetry()
initTurnstile()

createApp(App).use(store).use(router).mount('#app')
